import { useEffect } from "react";

/**
 * Trava o scroll do body enquanto active=true.
 *
 * - Reference-counted: múltiplos modais empilhados não se conflitam.
 * - iOS fix: usa position:fixed + top:-scrollY (overflow:hidden sozinho
 *   não funciona no Safari móvel — a página continua scrollável por baixo).
 * - Restaura a posição de scroll ao desbloquear.
 */

let lockCount = 0;

function lockBody() {
  if (lockCount === 0) {
    const scrollY = window.scrollY;
    document.body.dataset.scrollY = String(scrollY);
    document.body.style.overflow  = "hidden";
    document.body.style.position  = "fixed";
    document.body.style.top       = `-${scrollY}px`;
    document.body.style.width     = "100%";
  }
  lockCount++;
}

function unlockBody() {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount === 0) {
    const scrollY = parseInt(document.body.dataset.scrollY || "0", 10);
    document.body.style.overflow = "";
    document.body.style.position = "";
    document.body.style.top      = "";
    document.body.style.width    = "";
    window.scrollTo(0, scrollY);
  }
}

export function useBodyScrollLock(active = true) {
  useEffect(() => {
    if (!active) return;
    lockBody();
    return unlockBody;
  }, [active]);
}
